<app-header [breadcrumbs]="['Regions', 'Add a region']" mainHeading="Add a region"
            [links]="['/regions', '/add-region']" />
<main class="add-new-shell">
    <cll-horizontal-stepper [currentStepId]="currentStepId()"
                            (currentStepIdChange)="currentStepId.set($any($event))"
                            colour="secondary"
                            [items]="steps()"
                            [showDescription]="false" />
    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.basicDetails">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">person</cll-icon>
            <cll-card-title>Region basic details</cll-card-title>
        </cll-card-header>
        <div>
            <cll-form-field label="Region reference" class="w-full">
                <input cllFormInput [formControl]="regionDetailsFormGroup.controls.reference" type="text">
            </cll-form-field>
        </div>
        <div>
            <cll-form-field label="Region name" class="w-full">
                <input cllFormInput [formControl]="regionDetailsFormGroup.controls.name" type="text">
            </cll-form-field>
        </div>
    </cll-card>

    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.priorities">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">layers</cll-icon>
            <cll-card-title>Add priorities</cll-card-title>
        </cll-card-header>

        <div class="add-new-row-container">
            <cll-panel-tonal colour="info">
                <cll-icon cllPanelIcon>info</cll-icon>
                <div class="panel-text-group">
                    <span class="panel-text-header">Providers are placed into priorities</span>
                    <span class="panel-text-sub-header">With priorities, you can establish a hierarchy among providers when broadcasting a care package. You have control over the number of priority levels and can set a delay (in minutes) for each level. Providers in each priority level will gain access to newly published packages after the specified delay. For example, a priority level with a 0 minute delay will receive notification as soon as the care package is published, while a level with a 60 minute delay will be notified 60 minutes after publication.</span>
                </div>
            </cll-panel-tonal>
            <form [formGroup]="prioritiesForm">
                <div formArrayName="priorities">
                    <div *ngFor="let zone of prioritiesFormArray.controls; let i = index" [formGroupName]="i">
                        <hr *ngIf="i > 0" class="add-new-divider-small" />
                        <div class="priorities-top-row">
                            <div>
                                <cll-form-field label="Priority name" class="w-full">
                                    <input cllFormInput formControlName="name" />
                                </cll-form-field>
                            </div>
                            <div>
                                <cll-form-field label="Delay (in minutes)" class="w-full">
                                    <input cllFormInput formControlName="delay" type="number" min="0"
                                           max="10080" />

                                    <cll-number-control cllFormFieldControl />
                                </cll-form-field>
                            </div>
                            <div>
                                <button cll-button class="delete-button" type="button"
                                        (click)="removePriority(i)">
                                    <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                </button>
                            </div>
                        </div>
                        <cll-form-field label="Description" class="description-width">
                            <input cllFormInput formControlName="description" />
                        </cll-form-field>

                    </div>
                </div>
                <button cll-filled-button class="add-button" (click)="addPriority()">
                    <cll-icon cllButtonIcon>add</cll-icon>
                    Add priority
                </button>
            </form>
        </div>
    </cll-card>

    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.zones">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">explore</cll-icon>
            <cll-card-title>Add zones</cll-card-title>
        </cll-card-header>

        <div class="add-new-row-container">
            <cll-panel-tonal colour="info">
                <cll-icon cllPanelIcon>info</cll-icon>
                <div class="panel-text-group">
                    <span class="panel-text-header">Regions are split into zones</span>
                    <span class="panel-text-sub-header">A zone is a smaller area within a larger region. For example, particular boroughs or local areas within a city.</span>
                </div>
            </cll-panel-tonal>
            <form [formGroup]="zonesForm">
                <div formArrayName="zones">
                    <div *ngFor="let zone of zonesFormArray.controls; let i = index" [formGroupName]="i">
                        <hr *ngIf="i > 0" class="add-new-divider-small" />
                        <div class="add-zone-component">
                            <div>
                                <cll-form-field label="Zone name" class="w-full">
                                    <input cllFormInput formControlName="name" />
                                </cll-form-field>
                            </div>
                            <div>
                                <button cll-button class="delete-button" type="button" (click)="removeZone(i)">
                                    <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                </button>
                            </div>
                        </div>
                        <cll-form-field label="Zone description" class="w-full">
                            <input cllFormInput formControlName="description" />
                        </cll-form-field>

                    </div>
                </div>
                <button cll-filled-button class="add-button" (click)="addZone()">
                    <cll-icon cllButtonIcon>add</cll-icon>
                    Add zone
                </button>
            </form>
        </div>
    </cll-card>

    <cll-card>
        <div class="add-new-footer-buttons-container">

            <button cll-button (click)="cancel()">
                Cancel
            </button>

            <button cll-button type="button" (click)="goToPreviousStep()"
                    *ngIf="currentStepId() !== Step.basicDetails">
                Back
            </button>

            <button cll-filled-button colour="secondary" type="button" (click)="goToNextStep()" iconPosition="after"
                    *ngIf="currentStepId() !== Step.zones" [disabled]="!currentStepValid">Next
                <cll-icon>chevron_right</cll-icon>
            </button>

            <button cll-filled-button colour="secondary" (click)="createRegion()"
                    *ngIf="currentStepId() === Step.zones" [disabled]="!currentStepValid">
                <cll-icon>check</cll-icon>
                Create region
            </button>
        </div>
    </cll-card>
</main>
